import { render, staticRenderFns } from "./InteriorTab.vue?vue&type=template&id=12661538&scoped=true&"
import script from "./InteriorTab.vue?vue&type=script&lang=js&"
export * from "./InteriorTab.vue?vue&type=script&lang=js&"
import style0 from "./InteriorTab.vue?vue&type=style&index=0&id=12661538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12661538",
  null
  
)

export default component.exports